import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-disabled-or-delete',
  templateUrl: './disabled-or-delete.component.html',
  styleUrls: ['./disabled-or-delete.component.scss'],
})
export class DisabledOrDeleteComponent implements OnInit {
  @Input() organizationId: any = '';
  @Input() selfModal: NgbModalRef | null = null;
  @Output() refresh = new EventEmitter<any>();

  public faCircleNorch: any = faCircleNotch;

  public faTimes = faTimes;
  public loadSpin: boolean = false;

  constructor() {}

  ngOnInit(): void {}
  public disabledPlatform() {
    this.refresh.emit(this.organizationId);
    this.closeModal();
  }
  public closeModal() {
    if (this.selfModal) this.selfModal?.close();
    else $('ngb-modal-window').click();
  }
}
